import { useAuth } from "../context/AuthContext";

export default function Topbar() {
  const { user, logout } = useAuth();
  return (
    <header className="flex items-center justify-between px-7 py-4 border-b border-[rgb(var(--border))] bg-[rgb(var(--card))] shadow-sm">
      <div className="flex items-center gap-3.5">
        <div
          className="w-12 h-12 rounded-full flex items-center justify-center text-white text-sm font-bold shrink-0"
          style={{ background: "rgb(var(--primary))" }}
        >
          {user?.name?.[0]?.toUpperCase() || "?"}
        </div>
        <div>
          <div className="text-base font-semibold leading-tight">{user?.name}</div>
          {/* <div
            className="text-xs font-bold uppercase tracking-wider px-2.5 py-0.5 rounded-md mt-1 inline-block"
            style={{ background: "rgba(var(--primary),0.12)", color: "rgb(var(--primary))" }}
          >
            {user?.role}
          </div> */}
        </div>
      </div>
      <button
        onClick={logout}
        className="px-5 py-2 rounded-xl text-sm font-semibold border border-[rgb(var(--border))] hover:border-red-400 hover:text-red-500 transition-colors"
        style={{ color: "rgb(var(--fg))", background: "transparent" }}
      >
        Logout
      </button>
    </header>
  );
}